export default "__VITE_ASSET__0aabf85d__"